import { selectorFamily, SerializableParam, useRecoilValue } from 'recoil';
import { convertInvoiceDetails } from 'functions';
import { InvoiceService } from 'services';
import { isAuthenticated, refreshState, useSetRefreshState } from 'state';
import { InvoiceDetail } from 'types';

type InvoiceDetailParams = {
    accountId: string,
    vendorId: string,
    invoiceId: string,
    voucherId?: string,
} & SerializableParam;

export const invoiceDetails = selectorFamily<InvoiceDetail[], InvoiceDetailParams>({
    key: 'invoiceDetails',
    get: ({ accountId, vendorId, invoiceId, voucherId }) =>
        async ({ get }) => {
            get(refreshState(invoiceDetails({ accountId, vendorId, invoiceId, voucherId }).key))
            if (get(isAuthenticated) && accountId && vendorId && invoiceId) {
                const service = new InvoiceService();
                const data = await service.getInvoiceAdjustmentDetails(accountId, vendorId, invoiceId, undefined, undefined, voucherId);
                return convertInvoiceDetails(data);
            }
            return [];
        }
});

export const useInvoiceDetails = (accountId: string, vendorId: string, invoiceId: string, voucherId?: string) => useRecoilValue(invoiceDetails({ accountId, vendorId, invoiceId, voucherId }));

export const useRefreshInvoiceDetails = (accountId: string, vendorId: string, invoiceId: string, voucherId?: string) => useSetRefreshState(invoiceDetails({ accountId, vendorId, invoiceId, voucherId }));
